import { Controller } from "@hotwired/stimulus"

// Resets the Branding & Appearance color inputs back to their surface defaults.
// Each hex field target carries its default value in data-branding-reset-default.
// Setting the hex input and dispatching a bubbling "input" event lets the
// sibling color-picker controller re-sync its swatch and lets card-dirty mark
// the form dirty, so the agent still saves explicitly to persist the reset.
export default class extends Controller {
  static targets = ["field"]

  revert(event) {
    event.preventDefault()

    this.fieldTargets.forEach((field) => {
      const value = field.dataset.brandingResetDefault
      if (!value) return

      field.value = value
      field.dispatchEvent(new Event("input", { bubbles: true }))
    })
  }
}
